var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"subtitle-2 my-2"},[_vm._v("Selflane Deliveries")]),_c('Charts',{attrs:{"result":_vm.result}}),_c('div',{staticClass:"subtitle-2 my-2"},[_vm._v("Non-Selflane Deliveries")]),_c('Charts',{attrs:{"result":_vm.resultNonSelflane}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }